import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const CloseIcon = styled(IconButton)`
  position: absolute;
  top: 5px;
  right: 5px;

  font-size: 1.5rem;
`;

export const DialogStyled = styled(Dialog)`
  .MuiDialog-container {
    ${breakpoints.down('xs')} {
      align-items: stretch;
    }
  }

  .MuiDialog-paper {
    overflow-y: visible;

    ${breakpoints.down('xs')} {
      border-radius: 0;
      margin: 0;
      width: 100%;
      max-height: none;
    }
  }

  .MuiDialogContent-root {
    padding-bottom: 32px;

    &:first-child {
      padding-top: 35px;
    }
  }

  .MuiDialogActions-root {
    padding: 0;

    ${breakpoints.down('xs')} {
      display: block;
    }

    > button {
      min-width: 240px;

      ${breakpoints.down('xs')} {
        width: 100%;
      }
    }
  }
`;

export default DialogStyled;
